import Link from "next/link";
import { usePathname } from "next/navigation";
import Analytics from "@/lib/analytics";
import BookmarkIcon from "./icons/Bookmark";
import SignOutIcon from "./icons/SignOut";
import ProjectsIcon from "./icons/Projects";

type AccountNavigationProps = {
  handleLogout: () => void;
  location: string;
};

export const AccountNavigation = ({
  handleLogout,
  location,
}: AccountNavigationProps) => {
  const handleDropdownNavLinkClick = (clickedLink: string) => {
    Analytics.handleAccountDropdownNavLinkClick({
      param: clickedLink,
      target: location,
    });
  };

  const handleLogoutClick = () => {
    handleDropdownNavLinkClick("Sign Out");
    handleLogout();
  };

  const currentPath = usePathname();
  const matchesCurrentPath = (pathname: string) => {
    return currentPath.match(pathname);
  };

  return (
    <>
      <span className="mb-4 ml-3 mt-6 font-roobert text-sm font-normal text-gray-text">
        Workspace
      </span>
      <div className="mx-2 mb-2">
        <Link
          href="/account/saved-resources/component-skills"
          shallow={true}
          className={`flex rounded-lg px-4 py-[14px] font-roobert text-base font-medium leading-5 hover:bg-tab-bg-hover active:bg-tab-bg-press ${
            matchesCurrentPath("/account/saved-resources")
              ? "bg-xq-grey text-BG-60"
              : ""
          }`}
          onClick={() => handleDropdownNavLinkClick("Saved Resources")}
        >
          <BookmarkIcon
            stroke={
              matchesCurrentPath("/account/saved-resources")
                ? "#145758"
                : "#212121"
            }
            className="mr-4"
          />
          Saved Resources
        </Link>

        <Link
          href="/account/projects"
          shallow={true}
          className={`flex rounded-lg px-4 py-[14px] font-roobert text-base font-medium leading-5 hover:bg-tab-bg-hover active:bg-tab-bg-press ${
            matchesCurrentPath("/account/projects")
              ? "bg-xq-grey text-BG-60"
              : ""
          }`}
          onClick={() => handleDropdownNavLinkClick("Projects")}
        >
          <ProjectsIcon
            fill={
              matchesCurrentPath("/account/projects") ? "#145758" : "#212121"
            }
            className="mr-4"
          />
          Projects
        </Link>
      </div>

      <hr className="h-px w-full border-tab-border" />
      <span className="mb-4 ml-3 mt-6 font-roobert text-sm font-normal text-gray-text">
        Account
      </span>
      <div className="mx-2 mb-2 rounded-lg hover:bg-tab-bg-hover active:bg-tab-bg-press">
        <button
          onClick={handleLogoutClick}
          className="flex px-4 py-3 font-roobert text-base font-medium leading-5 "
        >
          <SignOutIcon className="mr-4" /> Sign Out
        </button>
      </div>
    </>
  );
};
